export const check_small = () => (
  <path
    d="m8 12.5 2.333 2.5L15 10"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
